import React, { Ref } from 'react';
import { HTMLFieldProps, connectField, filterDOMProps } from 'uniforms';

export type BoolFieldProps = HTMLFieldProps<
  boolean,
  HTMLDivElement,
  { inputRef?: Ref<HTMLInputElement> }
>;

function Bool({
  disabled,
  id,
  inputRef,
  label,
  name,
  onChange,
  readOnly,
  value,
  ...props
}: BoolFieldProps) {
  const customCallBack = () => {
    if (props.required) {
      if (!value) {
        value = true;
        !disabled && !readOnly && onChange(value);
      } else {
        !disabled && !readOnly && onChange(undefined);
      }
    } else {
      !disabled && !readOnly && onChange(!value);
    }
  };

  return (
    <div {...filterDOMProps(props)} className="flex h-8 items-center gap-2">
      <input
        checked={value || false}
        disabled={disabled}
        id={id}
        name={name}
        onChange={customCallBack}
        ref={inputRef}
        type="checkbox"
        className="checkbox checkbox-sm"
      />

      {label && (
        <label htmlFor={id} className="text-sm">
          {label}
        </label>
      )}
    </div>
  );
}

export default connectField<BoolFieldProps>(Bool, { kind: 'leaf' });
